export default __webpack_public_path__ + "static/media/image-banner-w@3x.7317b605.png";